import { PlainItemsSelector } from 'app/common/ui-next/plain-selector'
import { OrgType } from 'app/dataTypes/org/types'

import {
  filterActions,
  useFilterOptionsLoadingByKey,
  useFilterOptions,
  useFilter,
} from '../../filterStore'

import { sortByTitle, emptyArray } from './helpers'

export const OrgTypeControl = () => {
  const orgType = useFilter('orgType')
  const orgTypes = useFilterOptions('orgTypes')
  const loading = useFilterOptionsLoadingByKey('orgTypes')

  return (
    <PlainItemsSelector
      id="orgType"
      label="Тип заведения"
      header="Выбор типа заведения"
      pleaseSelectText="Все"
      items={orgTypes}
      selection={orgType.draft ? [orgType.draft] : emptyArray}
      defaultSelection={orgType.default ? [orgType.default] : emptyArray}
      onChange={(selected) => filterActions.selectDraftOrgType(selected[0] as OrgType | undefined)}
      loading={loading}
      sortFunc={sortByTitle}
      skipUpperSpace
    />
  )
}
